import PropTypes from "prop-types";
import * as React from "react";
import QuickActionTile from "../templates/quickActionTile";
import SingleLinkTile from "../templates/singleLinkTile";
import { quickActionTilesMap } from "../tilesMap";

const assaiEDMSUrl = GLOBAL_CONFIG.assaiEDMSUrl;

const AssaiEDMSTile = ({ id }) => {
    return (
        <QuickActionTile id={id}>
            <SingleLinkTile
                link={assaiEDMSUrl}
                linkText={quickActionTilesMap[id].description}
                title={"Assai - EDMS"}
            />
        </QuickActionTile>
    );
};

AssaiEDMSTile.propTypes = {
    id: PropTypes.string.isRequired,
};

export default AssaiEDMSTile;
